import React, { Component } from "react";
import { Panel, PanelGroup } from "rsuite";
import { Drawer } from "rsuite";
import { Button, Modal, TextField,Fade,Box,Typography, CircularProgress } from "@mui/material";
import JoditEditor from "jodit-react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Backdrop from "@mui/material/Backdrop";
import Autocomplete from '@mui/material/Autocomplete';
import ClearIcon from '@mui/icons-material/Clear';
import { ToastContainer, toast } from 'react-toastify';
const variableData=[
  {
    id: 2,
    title: "Variable",
    accordionServices: [
      {
        id: 1,
        text: "Email",
      },
      {
        id: 2,
        text: "First Name",
      },
      {
        id: 3,
        text: "Last Name",
      },
      {
        id: 4,
        text: "Phone Number",
      },
      {
        id: 5,
        text: "Company Name",
      },
      {
        id: 6,
        text: "Website",
      },
    ],
  },
]
const editorData = [
 
  {
    id: 2,
    type: "no",
    text: "Email AI",
  },
  {
    id: 3,
    type: "no",
    text: "Source code",
  },
  {
    id: 4,
    type: "no",
    text: "Unsubscribe link",
  },
  {
    id: 5,
    type: "no",
    text: "Calendly link",
  },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex:5000000,
};

const emojis = [
  { label: "Accusatory 👎", year:1200 },
  { label: "Angry 😡", year: 30000 },
  { label: "Appreciative 🙌", year: 1976 },
  { label: "Assertive ☝️", year: 1987 },
  { label: "Concerned 😟", year: 1765 },
  { label: "Confident 💪", year: 1098 },
  { label: "Cooperative 🤝", year: 2020},
  { label: "Curious 🤔", year: 2021},
  { label: "Disapproving 😖", year: 2023 },
  { label: "Egocentric 🧐", year: 2024},
  { label: "Empathetic 😌", year: 2024},
  { label: "Encouraging 👍", year: 2024},
  { label: "Enthusiastic 😀", year: 2024},
  { label: "Excited 🤩", year: 2024},
  { label: "Friendly 😉", year: 2024},
  { label: "Funny 😂", year: 2024},
  { label: "Joyful 😊", year: 2024},
  { label: "Neutral 🙂", year: 2024},
  { label: "Optimistic ✌️", year: 2024},
  { label: "Regretful 😥", year: 2024},
  { label: "Sad 🙁", year: 2024},
  { label: "Serious 😐", year: 2024},
  { label: "Surprised 😮", year: 2024},
  { label: "Unasumming 🙄", year: 2024},
  { label: "Worried 😨", year: 2024},
];

const data = [
  {title: 'Casual', year: 'Default'},
  {title: 'Formal', year: 'Default'},
  {title: 'Academic', year: 'Expository'},
  {title: 'Business', year: 'Expository'},
  {title: 'Essay', year: 'Expository'},
  {title: 'How-to', year: 'Expository'},
  {title: 'Instructions', year: 'Expository'},
  {title: 'Journalism', year: 'Expository'},
  {title: 'Legal', year: 'Expository'},
  {title: 'Technical', year: 'Expository'},
  {title: 'Anecdote', year: 'Creative'},
  {title: 'Biography', year: 'Creative'},
  {title: 'Fiction', year: 'Creative'},
  {title: 'Fiction', year: 'Creative'},
  {title: 'Poetry', year: 'Creative'},
  {title: 'Screenplay', year: 'Creative'},
  {title: 'Story', year: 'Creative'},
  {title: 'Advertising', year: 'Persuasive'},
  {title: 'Cover letter', year: 'Persuasive'},
  {title: 'Editorial', year: 'Persuasive'},
  {title: 'Marketing', year: 'Persuasive'},
]
const RecipientData = [
  {title: '5-10', year: 'Age range'},
  {title: '10-20', year: 'Age range'},
  {title: '20-30', year: 'Age range'},
  {title: '30-40', year: 'Age range'},
  {title: '40-50', year: 'Age range'},
  {title: '50-60', year: 'Age range'},
  {title: '60-70', year: 'Age range'},
  {title: '70+', year: 'Age range'},
  {title: 'Legal', year: 'Business'},
  {title: 'Accountant', year: 'Business'},
  {title: 'Applicant/Candidate', year: 'Business'},
  {title: 'Boss', year: 'Business'},
  {title: 'Coach', year: 'Business'},
  {title: 'Colleague', year: 'Business'},
  {title: 'Customer', year: 'Business'},
  {title: 'Customer Service', year: 'Business'},
  {title: 'Direct report', year: 'Business'},
  {title: 'Employee', year: 'Business'},
  {title: 'Journalist', year: 'Business'},
  {title: 'Lawyer', year: 'Business'},
  {title: 'Manager', year: 'Business'},
  {title: 'Partner', year: 'Business'},
  {title: 'Recruiter', year: 'Business'},
  {title: 'Sales lead / Prospect', year: 'Business'},
  {title: 'Supplier', year: 'Business'},
  {title: 'Tenant', year: 'Business'},
  {title: 'Vendor', year: 'Business'},
  {title: 'Banker', year: 'Private'},
  {title: 'Brother/Sister', year: 'Private'},
  {title: 'Child', year: 'Private'},
  {title: 'Doctor', year: 'Private'},
  {title: 'Friend', year: 'Private'},
  {title: 'Insurer', year: 'Private'},
  {title: 'Landlord', year: 'Private'},
  {title: 'Parent', year: 'Private'},
  {title: 'Patient', year: 'Private'},
  {title: 'Roommate', year: 'Private'},
  {title: 'Significant other', year: 'Private'},
  {title: 'Spouse', year: 'Private'},
  {title: 'Teammate', year: 'Private'},
  {title: 'Teenager', year: 'Private'},
  {title: 'Admin', year: 'Education'},
  {title: 'Professor', year: 'Education'},
  {title: 'Student', year: 'Education'},
  {title: 'Teacher', year: 'Education'}
]
const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
var substringLength=20
var emailContent=''
export class DrawerClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      pos: 0,
      open:false,
      open2:false,
      open3:false,
      open4:false,
      selectedVar:'',
      fallBackText:'',
      toggleDiv:false,
      unsubscribeLink:"",
      selectedFolder:'',
      folderName:'',
      allUserTemplate:[],
      templateName:'',
      subject:'',
      calendlyData: [],
      showToast:false,
      openMuiModal:false,
      aiEmailForm:{
        topicTitle:'',
        tone:'',
        writingStyle:'',
        Recipient:'',
        Details:'',
      },
      emailAiHtmlContent:'',
      showDangerousContent:false,
      isFetching:false,
      toneValue:'',
      activeAccordian:null,
    };
  }

  updateContent = (value) => {
    this.setState({
      content: value,
      pos: window.getSelection().getRangeAt(0).startOffset,
    });
  };
//   buttonClick = (text) => {
    
//     this.jodit.selection.insertHTML(`&nbsp<span class="clickable-span" style='display: inline;
//     padding: 4px 14px;
//     width:auto;
//     justify-content: center;
//     align-items: center;
//     gap: 10px;border-radius: 4px;
//     border: 1px solid var(--color-primary, #1C485F);
//     color: var(--color-primary, #1C485F);
//     text-align: center;
//     font-family: Source Sans Pro;
//     white-space: nowrap;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 20px;
//     cursor:pointer;
// ' contenteditable="false" class="clickable-span">${text}</span>&nbsp`);
//   };
buttonClick = (text,val,name) => {
  if (val === 1) {
    this.jodit.selection
      .insertHTML(`&nbsp<span class="clickable-span" style='display: inline;
  padding: 4px 14px;
  width:auto;
  justify-content: center;
  align-items: center;
  gap: 10px;border-radius: 4px;
  border: 1px solid var(--color-primary, #1C485F);
  color: var(--color-primary, #1C485F);
  text-align: center;
  font-family: Source Sans Pro;
  white-space: nowrap;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor:pointer;
' contenteditable="false" class="clickable-span">${text}</span>&nbsp`);
  } else {
    this.setState({open3:false})
    this.jodit.selection.insertHTML(
      `&nbsp<a style='color:#0000FF' href=${text} target="_blank" rel="noopener"> ${name} </a>&nbsp`
    );
  }
};
 getAllUserTemplate=()=>{
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user-template/get-user-template-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          this.setState({allUserTemplate:response.data.details.Template});
        } else {
          this.setState({allUserTemplate:[]});
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }    
      })
      .catch((err) => console.log("Error"));
  }
  componentDidMount() {
    // Add event listener for click events on spans within the editor
    document.addEventListener("click", this.handleSpanClick);
    this.getAllUserTemplate()
    this.setState({selectedFolder:this.props.selectedFolder})
    if(this.props.editableDataObj!==null){
      this.setState({templateName:this.props.editableDataObj.SubName})
      this.setState({content:this.props.editableDataObj.SubTemplate})
      this.setState({subject:this.props.editableDataObj.SubSubject})
    }
  }

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted
    document.removeEventListener("click", this.handleSpanClick);
  }
  handleSpanClick = (event) => {
    const clickedElement = event.target;

    // Check if the clicked element is a span with the specified class
    if (clickedElement.classList.contains("clickable-span")) {
      // alert(`Clicked on "${clickedElement.innerText}"`);
      this.setState({open:true})
      this.setState({selectedVar:clickedElement.innerText})
      // Add your custom logic here for handling the click event
    }
  };
  createFolderNameTemplate=()=>{
    let userData={
      templateName:this.state.folderName
    }
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/user-template/create-template/${
          userDetails && userDetails.details._id
        }`,
        userData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
         this.setState({folderName:''})
         this.getAllUserTemplate()
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
           
          }
        }
        
      })
      .catch((err) => console.log("Error"));

      
  }
 test = () => {
    return(
      <div style={{position:"relative"}}>
        <div onClick={()=>this.setState({toggleDiv:!this.state.toggleDiv})} style={{border:"1px solid #DDD",borderRadius:"6px",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px",cursor:"pointer"}}>
          <p> {this.state.selectedFolder?this.state.selectedFolder.Name:"selected folder here"}  </p>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M16.6004 7.45825L11.1671 12.8916C10.5254 13.5333 9.47539 13.5333 8.83372 12.8916L3.40039 7.45825" stroke="#393939" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        {
          this.state.toggleDiv && 
          <div style={{border:"1px solid #DDD",borderRadius:"6px",position:"absolute",bottom:0,top:40,zIndex:10000,width:"-webkit-fill-available",backgroundColor:"#fff",height:"max-content"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:"12px",borderBottom:"1px solid #DDD",padding:"4px"}}>
            <input
            value={this.state.folderName}
            onChange={(e)=>{this.setState({folderName:e.target.value})}}
            type="text" style={{flexGrow:1,padding:"10px",outline:"none",backgroundColor:"#FAFAFA",borderRadius:"4px",border:'1px solid #1C485F',}} placeholder="Create folder name"/>
            <button 
            onClick={()=>{
              this.createFolderNameTemplate()
            }}
            style={{backgroundColor:"#FAFAFA",borderRadius:"4px",padding:"10px 18px",color:"#000",outline:"none",border:"1px solid #DDD"}}>
              Create
            </button>
          </div>
          <ul style={{padding:"12px",border:'1px solid #DDD',zIndex:20000000}}>
            {this.state.allUserTemplate.length!==0&&this.state.allUserTemplate.map((val)=>{
              
              return(
                <li onClick={()=>{
                  this.setState({toggleDiv:!this.state.toggleDiv})
                  this.setState({selectedFolder:val})
                }} key={val._id} style={{padding:'12px',borderBottom:'1px solid #DDD',cursor:'pointer'}}>
                  {val.Name}
                </li>
              )
            })}
          </ul>
        </div>
        }
      </div>
    )
  }
  createTemplatetoFolder = () => {
    let tmpData={
      subName:this.state.templateName, 
      subTemplate:this.state.content,
      subSubject:this.state.subject
    }
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user-template/add-template-details/${
          userDetails && userDetails.details._id
        }/${this.state.selectedFolder._id}`,
        tmpData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          this.setState({templateName:''})
          this.setState({content:''})
          this.props.getAllUserTemplate()
          this.props.closeFun(false)
          this.props.setSelectedOption("")
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        
      })
      .catch((err) => console.log("Error"));
  };
  updateTemplatetoFolder = () => {
    let tmpData={
      subName:this.state.templateName, 
      subTemplate:this.state.content,
      subSubject:this.state.subject
    }
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user-template/update-template-details/${
          userDetails && userDetails.details._id
        }/${this.state.selectedFolder._id}/${this.props.editableDataObj._id}`,
        tmpData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          this.setState({templateName:''})
          this.setState({content:''})
          this.props.getAllUserTemplate()
          this.props.closeFun(false)
          this.props.setSelectedOption("")
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        
      })
      .catch((err) => console.log("Error"));
  };
  config = {
    readonly: false,
    events: {
      afterInit: (instance) => {
        this.jodit = instance;
      },
    },
    buttons: "undo,redo,image,video,link,font,fontsize,bold,italic,underline,ol,ul,center,justify,left,right",
    toolbarAdaptive: false, 
    showCharsCounter: false, 
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_only_text",
    cleanHTML: true,
    showXPathInStatusbar: false,
    statusbar:false,
  };
  jodit;
  setRef = (jodit) => (this.jodit = jodit);

  processEmailContent = () => {
    // Extract the next 10 characters
    const nextCharacters = emailContent.substring(0, substringLength);
    this.setState({
      content: nextCharacters,
      pos: window.getSelection().getRangeAt(0).startOffset,
    });
    // Increment the substring length for the next iteration
    substringLength += 10;
    // Check if we have reached the end of the string
    if (substringLength <= emailContent.length) {
      // Schedule the next iteration after the specified delay
      setTimeout(() => this.processEmailContent(), 200);
    } else {
      console.log("Reached the end of the string. Stopping further calls.");
    }
  };

  handleAiEmailFormSubmit = (e) => {
    e.preventDefault();
    if(this.state.aiEmailForm.Recipient===""){
      this.setState({showToast:true})
      toast.error("Recipient filed is missing",{autoClose: true,position:"top-right",duration: 3000});
      return;
    }
    
    if(this.state.aiEmailForm.tone===""){
      this.setState({showToast:true})
      toast.error("Tone filed is missing",{autoClose: true,position:"top-right",duration: 3000});
      return;
    }
    if(this.state.aiEmailForm.writingStyle===""){
      this.setState({showToast:true})
      toast.error("Writing style filed is missing",{autoClose: true,position:"top-right",duration: 3000});
      return;
    }
    
    // console.log("eamil data", this.state.aiEmailForm)
    let dynamicContent = `Generate a email content should be in html tag format containing topic to ${this.state.aiEmailForm.topicTitle}, for ${this.state.aiEmailForm.Recipient.title.includes('-' || '+') ? `Age range between ${this.state.aiEmailForm.Recipient.title} recipients` : this.state.aiEmailForm.Recipient.title}, tone is like ${this.state.aiEmailForm.tone.label}, writing style shoud be ${this.state.aiEmailForm.writingStyle.title} and ${this.state.aiEmailForm.Details} body in html`
    this.setState({isFetching:true})
    const api = `${
      BaseUrl.baseurl
    }/email-marketing/open-ai/generate-email-content`;
    axios
      .post(
        api,
        {"content":dynamicContent},
        {
          headers: {
            Authorization: `Bearer ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          // console.log("getting the reponse==========>", response.data.details);
          this.setState({emailAiHtmlContent:response.data.details})
          // this.setState({content:response.data.details})
          this.setState({showDangerousContent:true})
          this.setState({openMuiModal:false})
          this.setState({isFetching:false})
          emailContent=response.data.details
          this.processEmailContent()
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    
     
  }

  handleAiEmailFormOnchange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      aiEmailForm: {
        ...prevState.aiEmailForm,
        [name]: value,
      },
    }));
  }

  handleAutocompleteChange = (name, newValue) => {
    this.setState((prevState) => ({
      aiEmailForm: {
        ...prevState.aiEmailForm,
        [name]: newValue,
      },
    }));
    // console.log(`Selected ${name}:`, newValue);
  };

 muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={this.state.openMuiModal}
        onClose={() => this.setState({openMuiModal: false})}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={this.state.openMuiModal}>
          <Box sx={style}>
            <Box sx={{ display: "flex", justifyContent: "space-between",marginBottom:'12px' }}>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                sx={{
                  fontSize: "26px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                AI Email Writer
              </Typography>
              <Button
                disableRipple
                disableElevation
                sx={{
                  display: "flex",
                  outline: "none !important",
                  justifyContent: "flex-end",
                  padding: "0px",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
                onClick={() => this.setState({openMuiModal:false})}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>
            <form onSubmit={this.handleAiEmailFormSubmit} style={{display:"flex",flexDirection:"column",gap:"10px"}}>
              <div style={{display:"flex",flexDirection:"column",gap:"4px"}}>
                <label htmlFor="email-content"
                style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#4B4B4B",
                  }}>Email topic (200 chars max)</label>
                <input required value={this.state.aiEmailForm.topicTitle} name='topicTitle' onChange={this.handleAiEmailFormOnchange} id="email-content" type="text" style={{backgroundColor:"transparent",padding:"8px 12px",border:"1px solid #DDD",borderRadius:"4px",outline:"none",border:'1px solid #1C485F',}} />
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:"6px",width:"100%"}}>
                <label htmlFor="Tone"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#4B4B4B",
                }}>Tone</label>
                <Autocomplete
                  
                  disablePortal
                  id="combo-box-demo"
                  options={emojis}
                  size='small'
                  sx={{ width: '100%' }}
                  value={this.state.aiEmailForm.tone || null}
                  onChange={(event, newValue) => this.handleAutocompleteChange('tone', newValue)}
                  renderInput={(params) => <TextField autoComplete="off" {...params} label=" " InputLabelProps={{shrink:false}} sx={{border:'1px solid #1C485F',}}  required={params.length === 0} />}
                />
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:"6px",width:"100%"}}>
                <label htmlFor="writing-style"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#4B4B4B",
                }}>Writing style</label>
                  <Autocomplete
                    id="grouped-demo"
                    value={this.state.aiEmailForm.writingStyle || null}
                    size="small"
                    onChange={(event, newValue) => this.handleAutocompleteChange('writingStyle', newValue)}
                    options={data.sort((a, b) =>
                      b.year.toString().localeCompare(a.year.toString())
                    )}
                    groupBy={(option) => option.year}
                    getOptionLabel={(option) => option.title}
                    style={{ width: '100%' }}
                    renderInput={(params) => <TextField autoComplete="off" {...params} label=" " variant="outlined"
                    sx={{border:'1px solid #1C485F',}}
                    InputLabelProps={{ shrink: false }}
                     />}    
                  />
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:"6px",width:"100%"}}>
                <label htmlFor="writing-style"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#4B4B4B",
                }}>Recipient</label>
                  <Autocomplete
                    id="grouped-demo"
                    value={this.state.aiEmailForm.Recipient || null}
                    size="small"
                    onChange={(event, newValue) => this.handleAutocompleteChange('Recipient', newValue)}
                    options={RecipientData.sort((a, b) =>
                      b.year.toString().localeCompare(a.year.toString())
                    )}
                    groupBy={(option) => option.year}
                    getOptionLabel={(option) => option.title}
                    style={{ width: '100%' }}
                    renderInput={(params) => <TextField autoComplete="off" {...params} label=" " variant="outlined" InputLabelProps={{ shrink: false }} sx={{border:'1px solid #1C485F',}} />}    
                  />
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:"6px",width:"100%"}}>
                <label htmlFor="Details"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#4B4B4B",
                }}>Details (optional - 600 chars max)</label>
                <input type="text" id="Details" value={this.state.aiEmailForm.Details} name='Details' onChange={this.handleAiEmailFormOnchange} style={{padding:"8px 12px",backgroundColor:"transparent",borderRadius:"4px",outline:"none",border:"1px solid #DDD",border:'1px solid #1C485F',}} placeholder="Enter additional details you want to include" />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: "12px",
                  gap: "13px",
                }}
              >
                <button
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius:"4px"
                  }}
                  onClick={() => this.setState({openMuiModal:false})}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    textTransform: "none",
                    background:"#1C485F",
                    outline: "none",
                    color:"#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                    display:"flex",
                    alignItems: "center",
                    gap:"6px",
                  }}
                  >
                    {
                      this.state.isFetching && 
                      <CircularProgress
                        size={15}
                        style={{
                          color: "#FFF",
                        }} 
                      />
                    }
                      Generate
                </button>
              </div>
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  };
  getAllCalendlyData = (token, organization, reftoken) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://api.calendly.com/event_types?active=true&organization=${organization}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("nfnfnfnf", response.data.collection);
       
        this.setState({ open3: true });
        this.setState({
          calendlyData: response.data,
        });
      })
      .catch((error) => {
        this.createAccessToken(reftoken, organization);
      });
  };
  createAccessToken = (refToken, organization) => {
    axios
      .post(
        `https://calendly.com/oauth/token?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&client_secret=QP2iUiADJkDBQzFudVSdKU_llhekpna7sNZ73lLgqRQ&refresh_token=${refToken}&grant_type=refresh_token`
      )
      .then((result) => {
        if (result.data) {
          let accData = {
            calendlyAccessToken: result.data.access_token,
          };
          axios
            .put(
              `${
                BaseUrl.baseurl
              }/email-marketing/user/update-user-calendly-access-token/${
                userDetails && userDetails.details._id
              }`,
              accData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                this.getAllCalendlyData(
                  result.data.access_token,
                  organization,
                  refToken
                );
              } else {
                if (response.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        }
      })
      .catch((err) => console.log("Error"));
  };
  connectCalendly = () => {
    console.log('djfjfjf')
    const userDetailsFrom = JSON.parse(
      localStorage.getItem("MailSenderuserDetails")
    );
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetailsFrom && userDetailsFrom.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${
              userDetailsFrom && userDetailsFrom.token
            }`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if (response.data.details.CalendlyAddedStatus) {
            this.getAllCalendlyData(
              response.data.details.CalendlyAccessToken,
              response.data.details.CalendlyOrganization,
              response.data.details.CalendlyRefreshToken
            );
          } else {
            window.location.href="https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code"
            
          }
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };
  render() {
    return (
      <div
      style={{
        height: "100%",
        overflowY:'scroll',
      }}
      >
        <div
          style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "100%",
            // backgroundColor:'green',
            flexGrow:1
          }}
        >
          <div
            style={{
              padding: "8px 16px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            {this.props.editableDataObj===null&&(
                <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  marginBottom: "6px",
                }}
              >
                <p
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    marginBottom:'0px'
                  }}
                >
                  Create email template
                </p>
                {this.test()}
              </div>
            )}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2px" }}
            >
              <p
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                  marginBottom:'0px'
                }}
              >
                Name
              </p>
              <input
               value={this.state.templateName}
                onChange={(e)=>{
                  this.setState({templateName:e.target.value})
                }}
                type="text"
                style={{
                  outline: "none",
                  padding: "8px",
                  flexGrow: 1,
                  backgroundColor: "transparent",
                  border: "1px solid #DDD",
                  borderRadius: "6px",
                  border:'1px solid #1C485F',
                }}
                placeholder="Enter something here..."
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow:1,
              // backgroundColor:"yellow"
            }}
          >
            <div
            style={{
              // backgroundColor:"red",
              flexGrow:1,
              padding: "0px 16px",
              display: "flex",
              flexDirection: "column",
            }}>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "2px" }}
              >
                <p
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    marginBottom:'0px'
                  }}
                >
                  Subject
                </p>
                <input
                value={this.state.subject}
                  onChange={(e)=>{
                    this.setState({subject:e.target.value})
                  }}
                  type="text"
                  style={{
                    outline: "none",
                    padding: "8px",
                    flexGrow: 1,
                    backgroundColor: "transparent",
                    border: "1px solid #DDD",
                    borderRadius: "6px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    border:'1px solid #1C485F',
                  }}
                  placeholder="Enter subject here..."
                />
              </div>
              <div style={{position:"relative",backgroundColor:'#FFF',flexGrow:1,overflowY:"scroll",}}>
                <div style={{display:"flex",alignItems:'flex-start',gap:'20px',backgroundColor:"#FFF",borderRadius:'4px',width:"100%",position:"relative",borderRight:'1px solid #DDD'}}>
                  {/* <PanelGroup
                   accordion 
                   style={{flexShrink:0,display:"flex",
                   alignItems:"flex-start",gap:"12px",
                   position:"sticky",top:0,zIndex:500,
                   backgroundColor:"#FFF"}}
                   activeKey={this.state.activeAccordian}
                   onSelect={(newKey) => this.setState({ activeAccordian: newKey })}
                   >
                    {editorData.slice(0, 1).map((template,index) => (
                      <div key={index} style={{minWidth:"180px",position:"sticky",top:0,zIndex:20000,boxShadow: "20px 2px 4px 0px rgba(141, 141, 141, 0.15)",border:'1px solid red'}}>
                        <Panel
                          header={template.title}
                          eventKey={template.id}
                          id={`panel${template.id}`}
                        >
                          {template.accordionServices.map((service,idx) => (
                            <button
                              onClick={() => {
                                this.buttonClick(service.text);
                                this.setState({ activeAccordian: null })
                                // if(index===1){
                                //   console.log("service.tecxt",service.text)
                                //   this.buttonClick(service.text);

                                // } 
                              }}
                              key={idx}
                              style={{
                                outline: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "9px 16px",
                                cursor: "pointer",
                                backgroundColor: "#FFF",
                              }}
                            >
                              <p
                                style={{
                                  color: "#393939",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "13px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  backgroundColor: "transparent",
                                }}
                              >
                                {service.text}
                              </p>
                            </button>
                          ))}
                        </Panel>
                      </div>
                    ))}
                  </PanelGroup> */}
                  <PanelGroup
                   accordion 
                   style={{flexShrink:0,display:"flex",
                   alignItems:"flex-start",gap:"12px",
                   position:"sticky",top:0,zIndex:500,
                   backgroundColor:"#FFF",border:'1px solid #DDD',borderRadius:0}}
                   activeKey={this.state.activeAccordian}
                   onSelect={(newKey) => this.setState({ activeAccordian: newKey })}
                   >
                    {variableData.map((template,index) => (
                      <div key={index} style={{minWidth:"180px",position:"sticky",top:0,zIndex:20000}}>
                        <Panel
                          header={template.title}
                          eventKey={template.id}
                          id={`panel${template.id}`}
                        >
                          {template.accordionServices.map((service,idx) => (
                            <button
                              onClick={() => {
                                this.buttonClick(service.text, 1, "vig");
                                this.setState({ activeAccordian: null })
                                // if(index===1){
                                //   console.log("service.tecxt",service.text)
                                //   this.buttonClick(service.text);

                                // } 
                              }}
                              key={idx}
                              style={{
                                outline: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "9px 16px",
                                cursor: "pointer",
                                backgroundColor: "#FFF",
                              }}
                            >
                              <p
                                style={{
                                  color: "#393939",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "13px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  backgroundColor: "transparent",
                                }}
                              >
                                {service.text}
                              </p>
                            </button>
                          ))}
                        </Panel>
                      </div>
                    ))}
                  </PanelGroup>
                  <div style={{display:"flex",alignItems:"center",gap:"24px",flexGrow:1,paddingTop:'11px'}}>
                    {editorData.map((editor,idx) => (
                      <p
                        key={idx}
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "13px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          marginTop: "0px",
                          cursor:"pointer",
                        }}
                        onClick={()=>{
                          if(idx === 0){
                            this.setState({openMuiModal: true});
                          }
                          else
                          if(idx===3){
                            this.connectCalendly();
                          }
                          else if(idx===2){
                            this.setState({open4:true});
                          }
                          else if(idx===1){
                            this.setState({open2: true});
                          }
                        }}
                      >
                        {editor.text}
                      </p>
                    ))}
                  </div>
                </div>
                <div style={{width:'100%',position:'absolute',top:40,height: '-webkit-fill-available'}}>
                  <JoditEditor
                    ref={this.setRef}
                    value={this.state.content}
                    config={this.config}
                    tabIndex={1} // tabIndex of textarea
                    onBlur={this.updateContent}
                    // onChange={this.updateContent}
                  />
                </div>
              </div>
            </div>
            <div
            style={{
              // backgroundColor: "red",
              display: "flex",
              padding: "8px 16px",
              borderTop: "1px solid #DDD",
              justifyContent:'flex-end',
              position: "relative",
              // zIndex:2000
            }}
          >
            <button
            onClick={()=>{
              if(this.props.editableDataObj!==null){
                 this.updateTemplatetoFolder()
              }
              else
              {
                this.createTemplatetoFolder()
              }
             
            }}
              style={{
                padding: "10px 16px",
                borderRadius: "4px",
                color: "#fff",
                outline: "none",
                backgroundColor: "#1C485F",
                alignSelf: "flex-end",
                // opacity:(this.state.subject===""||this.state.selectedFolder===""||this.state.templateName==="")&&0.4,
                pointerEvents:(this.state.subject===""||this.state.selectedFolder===""||this.state.templateName==="")&&'none'

              }}
            >
              {this.props.editableDataObj!==null?"Update":'Next'}
            </button>
            </div>
          </div>         
        </div>
        <style>
          {`
                .rs-drawer-header .rs-drawer-header-close{
                    display: none;
                }
            `}
        </style>
        {
          this.state.openMuiModal && this.muiModal()
        }
        {this.state.open&&(
        <Modal
        open={this.state.open}
        onClose={() => {
          this.setState({open:false});
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Fallback</div>
          <div className="modalsubtext">
          Add fallback text for variable <span style={{color:'black',fontWeight:'bolder'}}>{this.state.selectedVar}</span> if we can't find this data in the leads profile
          </div>
          <TextField
          autoComplete="off"
                value={this.state.fallBackText}
                onChange={(e) => {
                  this.setState({fallBackText:e.target.value});
                }}
                variant="standard"
                placeholder="Enter fallback text"
                InputProps={{
                  disableUnderline: true,

                  sx: {
                    display: "flex",
                    padding: "10px 16px",
                    alignItems: "center",
                    gap: "10px",
                    borderRadius: "4px",
                    border:'1px solid #1C485F',
                    background: "var(--background-color, #FAFAFA)",
                    width:'26vw',
                    "& input": {
                      color: "#868686",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "20px",
                    },
                  },
                }}
              />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                this.setState({open:false});
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              // onClick={() => {
              //   deleteScheduleById();
              // }}
            >
              Save
            </div>
          </div>
        </div>
      </Modal>
      )}
       {this.state.open4&&(
         <div
         className="modalPopupDelete"
         style={{
          top:'24%',
          width:'40vw',
          left:'25%',
           borderRadius: "10px",
           background: "var(--color-white, #FFF)",
           boxShadow: "4px 4px 10px 4px #DDD",
           flexDirection: "column",
           alignItems: "flex-start",
           gap: "16px",
           padding: "20px",
           paddingBottom: "10px",
         }}
       >
          <div className="modaltext">Unsubscribe Link</div>
          <div className="modalsubtext">
          Enter the link text. This is the text that will offer your recipients to unsubscribe, for example: Click here to unsubscribe. Coldsender.com will generate and add your custom unsubscribe link to it.
          </div>
          <TextField
          autoComplete="off"
                value={this.state.unsubscribeLink}
                onChange={(e) => {
                  this.setState({unsubscribeLink:e.target.value});
                }}
                variant="standard"
                placeholder="For example: Click here to unsubscribe"
                InputProps={{
                  disableUnderline: true,

                  sx: {
                    display: "flex",
                    padding: "10px 16px",
                    alignItems: "center",
                    gap: "10px",
                    borderRadius: "4px",
                    border:'1px solid #1C485F',
                    background: "var(--background-color, #FAFAFA)",
                    width:'37vw',
                    "& input": {
                      color: "#868686",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "20px",
                    },
                  },
                }}
              />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                this.setState({open4:false});
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                this.buttonClick(
                  'https://app.coldsender.com/UnSubscribe/unsubscribemail/unsubscribecampaignid',
                  2,
                  this.state.unsubscribeLink
                );
                this.setState({open4:false})
                this.setState({unsubscribeLink:''})
              }}

            >
              Insert
            </div>
          </div>
        </div>
      )}
       {this.state.open2&&(
        <Modal
        open={this.state.open2}
        onClose={() => {
          this.setState({open2:false});
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete" style={{top: "10%",left: "15%",width:'70vw',height:'80vh',overflowY:'scroll'}}>
          {this.state.content}
        </div>
      </Modal>
      )}
        {this.state.showToast && <ToastContainer />}
        {this.state.open3&&(
                <div
                className="modalPopupDelete"
                style={{
                  top: "45%",
                  left: "40%",
                  width: "23vw",
                  borderRadius: "10px",
                  background: "var(--color-white, #FFF)",
                  boxShadow: "0px 2px 10px 0px rgba(25, 1, 52, 0.12)",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "16px",
                  padding: "0px",
                  paddingBottom: "10px",
                }}
              >
                <div className="calendlymeethead">Available Calendly meeting <ClearIcon style={{cursor:'pointer'}} onClick={()=>{this.setState({open3:false})}} /></div>
                
                <div className="listcalendlybos">
                  {this.state.calendlyData.collection.length===0&&<div className="subheadcalendl">No Calendly Link present. Please create calendly schedule in calendly site.</div>}
                  
                  {this.state.calendlyData.length !== 0 &&
                    this.state.calendlyData.collection.map((val) => {
                      let dmUrl = val.scheduling_url;
                      return (
                        <>
                          {val.active && (
                            <>
                              <div className="insideboixcalend">
                                <div className="calendtexthead">{val.name}</div>
                                <div className="subheadcalendl">
                                  {val.duration}mins /
                                  {dmUrl.replace("https://calendly.com/", "")}
                                </div>
                              </div>
                              <div
                                className="inserlinkcALEND"
                                onClick={() => {
                                  this.buttonClick(
                                    val.scheduling_url,
                                    2,
                                    val.name
                                  );
                                  this.setState({open3:false})
                                }}
                              >
                                Insert link
                              </div>
                            </>
                          )}
                        </>
                      );
                    })}
                </div>
                </div>
              )}
      </div>
    );
  }
}

export default DrawerClass;
